import { ajaxActions } from 'common/ajax/store.js';
import { oidcConfig } from 'common/config.js';
import UserData from 'common/sessionStore/userPreferences';
import { actionCreators as authActions } from 'common/auth/store';

const UPDATE_TC_ACCEPTED = 'UPDATE_TC_ACCEPTED';
const TC_READ = 'TC_READ';
const TC_ACCEPT_CHECKED = 'TC_ACCEPT_CHECKED';
const initialState = {
  termsAndConditions: false,
  tcRead: false,
  tcAccpetChecked: false,
  hasAcceptedTC: false,
};

export const actionCreators = {
  updateTCAccepted: (params) => async (dispatch, getState) => {
    let url = `${oidcConfig.authority}/api/TermsAndConditions/AcceptTermsAndConditions/`; //api in IdentityServer
    dispatch(
      ajaxActions.sendAjaxRequest(
        url,
        'PUT',
        (result) => {
          dispatch(authActions.acceptTc());
          const { userId } = getState().auth;
          new UserData().setTcAccepted(userId); //save tc acceptance in localStorage
        },
        null,
        false
      )
    );
  },
  updateTCRead: () => async (dispatch, getState) => {
    dispatch({ type: TC_READ, tcRead: true });
  },
  updateTCAccpetChecked: (checked, params) => async (dispatch, getState) => {
    dispatch({ type: TC_ACCEPT_CHECKED, tcAccpetChecked: checked });
  },
};

export const reducer = (state, action) => {
  state = state || initialState;
  if (action.type === UPDATE_TC_ACCEPTED) {
    return {
      ...state,
      termsAndConditions: action.termsAndConditionsResult,
      hasAcceptedTC: true,
    };
  }
  if (action.type === TC_READ) {
    return {
      ...state,
      tcRead: action.tcRead,
    };
  }
  if (action.type === TC_ACCEPT_CHECKED) {
    return {
      ...state,
      tcAccpetChecked: action.tcAccpetChecked,
    };
  }

  return state;
};
